import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AlertService } from '../../../services/alert.service';
import { InputWrapper } from '../../common/input-wrapper';
import { api } from '../../../services/api';
import { FormattedMessage, useIntl } from 'react-intl';

type Form = {
  name: string;
};

type Props = {
  close: () => void;
  reject: () => void;
  oldName: string;
};

export const DeliveryChangeStorageLocationName: React.FC<Props> = (props) => {
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<Form>({ defaultValues: { name: props.oldName } });
  const intl = useIntl();
  const onSubmit = handleSubmit(async (form) => {
    await api.post(`/delivery-order/storage-location`, {
      oldName: props.oldName,
      newName: form.name,
    });

    AlertService.success();
    props.close();
  });

  return (
    <div className="modal-dialog">
      <form className="modal-content" onSubmit={onSubmit}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>
            <FormattedMessage
              defaultMessage="Укажите наименование места"
              id="deliveryOrder.changeLocation"
              description="Надпись на кнопке/заголовок"
            />
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>

        <div className="modal-body p-4 pt-0">
          <div className="row mb-3">
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <InputWrapper
                    title={intl.formatMessage({
                      defaultMessage: 'Укажите новое наименование',
                      id: 'deliveryChangeStorageLocationName.input-label.name',
                      description: 'Заголовок поля ввода',
                    })}
                    required
                    error={fieldState.error?.message}
                  >
                    <input className="form-control" {...field}></input>
                  </InputWrapper>
                );
              }}
            />
          </div>
        </div>
        <div className="modal-footer pt-3 p-4 justify-content-center d-flex gap-2">
          <div className="btn btn-light" onClick={() => props.close()}>
            {intl.formatMessage({
              id: 'deliveryOrder.cancel',
              defaultMessage: 'Отмена',
              description: 'Надпись на вкладке',
            })}
          </div>
          <button
            type="submit"
            className="btn btn-success"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Обновить"
                id="deliveryChangeStorageLocationName.btn.update"
                description="Надпись на кнопке"
              />
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
